export enum COUNT_BADGE_TYPE {
  BADGE = "badge",
  TEXT = "text",
}

export const countBadgeColorMap: Record<"primary" | "basic", string> = {
  primary: "bgPrimary",
  basic: "bgBasic",
};
